import Cookies from "js-cookie";

export const TOKEN_KEY = "access_token_new"; // token名
export const COOKIE_EXPIRES = 1; // cookie存储时间，暂定 1天

export default {
  // 存、取、移除token
  set(token) {
    Cookies.set(TOKEN_KEY, JSON.stringify(token), { expires: COOKIE_EXPIRES });
  },
  getAll() {
    let token = Cookies.get(TOKEN_KEY);
    return token;
  },
  get(key) {
    let token = Cookies.get(TOKEN_KEY);
    if (token) {
      token = JSON.parse(token);
      return key ? token[key] : token;
    }
    return key ? "" : {};
  },
  remove() {
    Cookies.remove(TOKEN_KEY);
  },

  setRTByKey(key = "", value = "") {
    let token = Cookies.get(TOKEN_KEY);
    if (token) {
      token = JSON.parse(token);
      token[key] = value;
      Cookies.set(TOKEN_KEY, JSON.stringify(token), { expires: COOKIE_EXPIRES });
    }
  },
};
